globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Reviews = appCustomerSpace.Modals.Reviews || {};

appCustomerSpace.Modals.Reviews.SelectReplyTemplate = (function(superClass) {

	utils.extend(SelectReplyTemplate, superClass);

	function SelectReplyTemplate() {
		return SelectReplyTemplate.__super__.constructor.apply(this, arguments);
	}

	$.extend(SelectReplyTemplate.prototype, {
		init: function() {
			var modal = this;

			SearchFilter.initFilters(this.$html.find('.input-filter'));

			var $modal = modal.$html,
					url = $modal.data('modal-url'),
					errorMsg = 'Erreur de chargement du modèle',
					reviewId = $modal.data('review-id'),
					$reviewItemThumbnail = $(`.review-item-thumbnail#review-${reviewId}`),
					$replyComment = $reviewItemThumbnail.find('.reply-comment-textarea'),
					$replyTemplateIdInput = $reviewItemThumbnail.find(`#reviews-${reviewId}-reply-template-id-input`);

			// Update reply comment with reply template content
			$modal.find('.media-link').each(function() {
				$(this).on('click', function(e) {
					e.preventDefault();
					var $container = $(this),
							selectedTemplateId = $(this).data('template-id');

					appCustomerSpace.Loader().start({ $container: $container });

					if (url) {
						$.ajax({
							type: "GET",
							url: url,
							data: {
								selected_template_id: selectedTemplateId,
								review_id: reviewId
							},
							success: function(data)
							{
								if (data.response == 1) {
									$replyComment.val(data.reply_template_content);
									$replyTemplateIdInput.val(selectedTemplateId);
									modal.close();
									appCustomerSpace.Loader().stop({ $container: $container });
								} else {
									alert(errorMsg);
								}
							}
						}).fail(function() {
							alert(errorMsg);
						});
					}
				});
			});

			return SelectReplyTemplate.__super__.init.apply(this, arguments);
		}
	});

	return SelectReplyTemplate;

})(appCustomerSpace.Modal);
